<template>
  <div class="newteamAssessment">
    <div class="con">
      <div class="left-li">
        <elRadioUnitTree @clickItem="clickItem"></elRadioUnitTree>
      </div>
      <div class="middle-tab">

        <div class="Files-top">
          <div class="ic-left">
            <span>班组管理</span>
          </div>
          <div class="btns">
            <el-button type="primary" @click="add_ed" class="last-el-button">新增</el-button>
          </div>
        </div>
        <div class="mytbale" :style="{'height':heights+'px'}">
          <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :height="heights">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="90" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="className" label="班组名称"> </el-table-column>
            <el-table-column label="开始时间">
              <template slot-scope="scope"><span>{{ scope.row.startTime | date_format}}</span></template>
            </el-table-column>
            <el-table-column label="结束时间">
              <template slot-scope="scope"><span>{{ scope.row.endTime | date_format}}</span></template>
            </el-table-column>
            <el-table-column label="状态" width="180" align="center">
              <template #default="{row}">
                <span>
                  <el-switch v-model="row.check" active-color="#409eff" inactive-color="#dcdfe6"
                    @change="switch_fn(row.check,row)"></el-switch>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="{row}">
                <span class="buttoned_box new-table-button">
                  <el-button type="text" @click="edit_ed(row)" class="edit-btn">编辑</el-button>
                  <span class="line"></span>
                  <el-button type="text" @click="del_fn(row)" class="del-btn">删除</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>

    </div>
    <!-- 新增修改 -->
    <el-dialog width="20%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible" class="unify-dialog">
      <div style="display: flex;">
        <el-form :model="temp" ref="temp" style="width: 95%;height: 170px;padding-top: 10px;">
          <el-form-item label="班组名称:" prop="className">
            <el-input v-model="temp.className" style=""></el-input>
          </el-form-item>

          <el-form-item label="开始时间:" prop="startTime">
            <el-time-select v-model="temp.startTime" :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '24:00'
                                }" placeholder="选择开始时间">
            </el-time-select>
          </el-form-item>
          <el-form-item label="结束时间:" prop="endTime">
            <el-time-select v-model="temp.endTime" :picker-options="{
                                    start: '00:00',
                                    step: '00:30',
                                    end: '24:00'
                                }" placeholder="选择结束时间">
            </el-time-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import elRadioUnitTree from '@/components/module/newTree/elRadioUnitTree.vue'
  import {getTeamstGroups,setClassTeamSave,deleteClassTeam} from "../../api/fangzheng.js";
  export default {
    components: {
      elRadioUnitTree
    },

    data () {
      return {
        heights: document.getElementById('app').clientHeight-210,
        itemActive: "1",//高亮
        roleList: [],
        tableData: [],
        loading: false,
        temp: {},
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增班组",
          edit: "编辑班组"
        },
        nowUnitId: ""



      };
    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },

    },
    watch: {
      unitId (val) {
        this.nowUnitId=val.id
        this.getTeamstGroups_fn() // 获取列表数据
      },
    },

    mounted () {
      this.nowUnitId=this.unitId.id
      this.getTeamstGroups_fn()
    },


    methods: {
      //点击树状图
      clickItem (val) {
        this.nowUnitId=val.id
        this.getTeamstGroups_fn()
      },
      //获取列表
      getTeamstGroups_fn () {
        this.loading=true
        getTeamstGroups({'unitId': this.nowUnitId}).then(res => {
          if(res.code==200) {
            var list=res.data
            list.forEach(item => {
              if(item.check==1) {
                item.check=true
              } else {
                item.check=false
              }
            })
            this.tableData=list
            this.loading=false
          } else {
            this.loading=false
          }
        })
      },
      // 添加弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.temp={}
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var d={
              'className': this.temp.className,
              'startTime': this.tranTimerStr(this.temp.startTime),
              'endTime': this.tranTimerStr(this.temp.endTime),
              'unitId': this.nowUnitId
            }
            setClassTeamSave(d).then(res => {
              if(res.code==200) {
                this.getTeamstGroups_fn();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              'className': data.className,
              'startTime': this.tranTimerStr(data.startTime),
              'endTime': this.tranTimerStr(data.endTime),
              'check': data.check? 1:0,
              'unitId': data.unitId,
              'uid': data.id
            }
            setClassTeamSave(d).then(res => {
              if(res.code==200) {
                this.getTeamstGroups_fn();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('修改失败');
                }
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.temp.startTime=this.tranTimer(this.temp.startTime)
        this.temp.endTime=this.tranTimer(this.temp.endTime)
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //启用
      switch_fn (val,row) {
        console.log("状态",val);
        var dateStatus=val? 1:0
        var tip=val? '启用':'禁用'
        var d={
          'className': row.className,
          'startTime': row.startTime,
          'endTime': row.endTime,
          'check': dateStatus,
          'unitId': row.unitId,
          'uid': row.id
        }
        setClassTeamSave(d).then(res => {
          if(res.code==200) {
            if(val) {
              this.$message({showClose: true,message: `${row.className} 启用成功`,type: 'success'});

            } else {
              this.$message({showClose: true,message: `${row.className} 禁用成功`,type: 'warning'});
            }
          } else {
            this.$message.error(`${row.className} ${tip}失败`);
          }
        })
      },
      //单个删除
      del_fn (row) {
        this.$confirm(`是否删除 ${row.className}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteClassTeam({"teamId": row.id}).then(res => {
            if(res.code==200) {
              this.getTeamstGroups_fn();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //转换上下班时间字符串
      tranTimerStr (timeStr) {
        var time=timeStr;
        var [hours,minutes]=time.split(':');
        var date=new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        var milliseconds=date.getTime();

        return milliseconds
      },
      //时间
      tranTimer (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s="00";
        let strDate=h+m+s;
        return strDate
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s="00";
        let strDate=h+m+s;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .newteamAssessment {
    overflow: hidden;

    .con {
      width: 100%;
      height: 100%;
      display: flex;
      box-sizing: border-box;
    }

    .left-li {
      width: 300px;
      height: 100%;
      background-color: #fff;
      padding: 12px;
      box-sizing: border-box;
      margin-right: 8px;
    }

    .newtable-title {
      height: 40px;
    }

    .middle-tab {
      width: calc(100% - 308px);
      background-color: #fff;
      border-right: 1px solid #E6E6E6;
      padding: 12px 20px 20px 20px;
      box-sizing: border-box;
      position: relative;

      .mytbale {
        width: 100%;
        height: 95%;
        margin-top: 20px;
      }


    }

    /deep/.unify-dialog .el-form-item__label {
      width: 68px !important;
    }


  }
</style>